module.exports = __webpack_public_path__ + "static/media/0-1.46b759d8.svg";